import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, IconButton } from '@mui/material';
import { CloudUpload, Close } from '@mui/icons-material';

const UploadModal = ({ open, onClose, onOk, fileType, file, fileName, onFileChange }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {fileType === 'video' ? 'Subir Video' : 'Subir Material'}
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Button
          variant="contained"
          component="label"
          sx={{ background: '#4DABA4', color: '#fff', fontWeight: 600, mr: 2 }}
        >
          Elegir Archivo
          <input
            type="file"
            hidden
            accept={fileType === 'video' ? '.mp4,.mov,.avi,.mkv,.webm' : '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip'}
            onChange={onFileChange}
          />
        </Button>
        <Typography sx={{ flex: 1, fontWeight: 600, color: '#4DABA4' }}>{fileName}</Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
      <Button
        onClick={onOk}
        className="background-green-aqua"
        variant="contained"
        disabled={!file}
      >
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);

export default UploadModal; 